function setupListenererForInsertAttachement(component) {
    component.container.addEventListener('event-emit-select-insert-attachment', event => {
        const html = JSON.parse(event.target.closest('[data-drag-content]').getAttribute('data-drag-content'))['text/html'];
        const url = html.match(/href="([^"]*)"/)[1]; // Extract href value
        const fileName = html.replace(/<[^>]*>/g, ''); // Extract text content
        const mediaType = determineMediaType(fileName);

        let htmlTemplate;
        console.log(fileName);
        console.log(mediaType);

        if (mediaType === 'video') {
            htmlTemplate = `<video controls="controls" width="300" height="150">\n<source src=${url}></video>`;
        } else if (mediaType === 'image') {
            htmlTemplate = `<img src=${url} alt="Inserted Image">`;
        } else {
            htmlTemplate = '<p>Unknown media type</p>';
        }

        window.$events.emit('editor::insert', {
            html: htmlTemplate,
        });
    });
}

function determineMediaType(fileName) {
    const fileExtension = fileName.split('.').pop().toLowerCase();

    if (['mp4', 'avi', 'mov'].includes(fileExtension)) {
        return 'video';
    } if (['png', 'jpg', 'jpeg', 'gif'].includes(fileExtension)) {
        return 'image';
    }

    return 'unknown';
}

export function getCustomListeners(attachement) {
    setupListenererForInsertAttachement(attachement);
}
